






















































































import Vue from "vue";
import Editor, { IEditorEmitArgs } from "@/components/molecules/Editor.vue";
import ManuscriptPreview from "@/components/organisms/ManuscriptPreview.vue";
import TextVerticalIcon from "@/components/atoms/TextVerticalIcon.vue";
import LinkIcon from "@/components/atoms/LinkIcon.vue";
import DropupMenu, { Item } from "@/components/molecules/DropupMenu.vue";
import HamburgerMenu from "@/components/molecules/HamburgerMenu.vue";
import { Manuscript, ManuscriptSetting, Novel, Plan, SearchTextIndex } from "@/lib/models";
import clone from "lodash/cloneDeep";
// NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
// import { downloadPublicImage } from "@/lib/s3";
// import PremiumFeatureDialog, { PremiumFeatureDialogProps } from "@/components/ui/PremiumFeatureDialog.vue";
import ManuscriptSettingsDialog, { ManuscriptSettingsDialogProps } from "@/components/ui/ManuscriptSettingsDialog.vue";
import ExportManuscriptPdfDialog, {
  ExportManuscriptPdfDialogProps,
} from "@/components/ui/ExportManuscriptPdfDialog.vue";
import ColorThemeDialog from "@/components/ui/ColorThemeDialog.vue";
import VersionsDialog, { VersionsDialogProps } from "@/components/ui/VersionsDialog.vue";
import EditorController from "@/components/molecules/EditorController.vue";
import ProofreadingSettingsDialog from "@/components/ui/ProofreadingSettingsDialog.vue";
import { UserClient } from "@/lib/clients";
// dialog
import { Dialog } from "@/lib/utils";
import DialogVue from "@/components/ui/Dialog.vue";
import { showOkCancelDialog, openManuscriptEditorMenuDialog } from "@/lib/dialog";
import EpisodeListDialog, { EpisodeListDialogProps } from "@/components/ui/nolaNovel/EpisodeListDialog.vue";
import NolaNovelIntroduction from "@/components/ui/nolaNovel/NolaNovelIntroduction.vue";
import CupertinoAlertDialog, { CupertinoAlertDialogProps } from "@/components/ui/dialogs/CupertinoAlertDialog.vue";
import NolaNovelUpdateConfirm, {
  NolaNovelUpdateConfirmProps,
} from "@/components/ui/nolaNovel/NolaNovelUpdateConfirm.vue";
import EpisodeDelinkConfirm, { EpisodeDelinkConfirmProps } from "@/components/ui/nolaNovel/EpisodeDelinkConfirm.vue";
import ProofreadingConfirmationDialog from "@/components/ui/ProofreadingConfirmationDialog.vue";
import AutoIndentConfirmationDialog from "@/components/ui/AutoIndentConfirmationDialog.vue";

const contentMaxLenth = 100000;

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Editor,
    ManuscriptPreview,
    TextVerticalIcon,
    LinkIcon,
    DropupMenu,
    HamburgerMenu,
    EditorController,
    ProofreadingConfirmationDialog,
    AutoIndentConfirmationDialog,
  },

  props: {
    novelId: String,
    manuscriptKey: String,
  },

  data() {
    const {
      onSelectCountType,
      showManuscriptSettings,
      showColorTheme,
      showProofreadingSettings,
      showExportManuscriptPdf,
      showVersions,
    } = this as any;

    const countTypeList: Item[] = [
      {
        name: "全文字数",
        value: "onlyCharacter",
        callback() {
          onSelectCountType(this.value);
        },
      },
      {
        name: "空白を含む全文字数",
        value: "addBlank",
        callback() {
          onSelectCountType(this.value);
        },
      },
      {
        name: "改行を含む全文字数",
        value: "addNewLine",
        callback() {
          onSelectCountType(this.value);
        },
      },
      {
        name: "空白/改行を含む全文字数",
        value: "all",
        callback() {
          onSelectCountType(this.value);
        },
      },
    ];

    const hamburgerMenuItems: Item[] = [
      {
        name: "PDFで出力する",
        icon: "tray-arrow-down",
        callback() {
          showExportManuscriptPdf();
        },
      },
      {
        name: "過去の執筆履歴",
        icon: "history",
        callback() {
          showVersions();
        },
      },
      {
        name: "原稿用紙の設定",
        icon: "note-text-outline",
        callback() {
          showManuscriptSettings();
        },
      },
      {
        name: "カラーテーマ選択",
        icon: "palette",
        callback() {
          showColorTheme();
        },
      },
      {
        name: "自動校正機能の設定",
        icon: "checkbox-marked-outline",
        callback() {
          showProofreadingSettings();
        },
      },
    ];

    return {
      title: "",
      preTitle: "",
      content: "",
      preContent: "",
      saved: false,
      countTypeList,
      hamburgerMenuItems,
      hasNolaNovelAccount: false,
    };
  },

  async created() {
    const { initialize } = this;
    initialize();
  },

  destroyed() {
    this.initializeSearchState();
  },

  watch: {
    saveTimeout() {
      if (this.saveTimeout) {
        this.save();
        this.$store.dispatch("manuscriptModule/stopSaveTimeout");
      }
    },
    content: {
      handler() {
        this.setModified(this.changed);
        this.updateSearchState();
      },
      immediate: true,
    },
    searchText: {
      handler() {
        this.updateSearchState();
      },
      immediate: true,
    },
    enabledSearch(value: boolean) {
      if (!value) return;
      const { searchTargetIndex, searchTextIndexList, scrollToTargetText, focusInputSearch } = this;
      const { from } = searchTextIndexList[searchTargetIndex];
      scrollToTargetText(from);
      focusInputSearch();
      this.$store.dispatch("manuscriptModule/toggleEnabledSearch");
    },
    enabledReplaceSingle(value: boolean) {
      const {
        searchTextIndexList,
        searchTargetIndex,
        replaceText,
        scrollToTargetText,
        selectTargetText,
        executeReplaceText,
      } = this;

      if (value) {
        const { from, to } = searchTextIndexList[searchTargetIndex];
        executeReplaceText(from, to);
        this.$store.dispatch("manuscriptModule/toggleEnabledReplaceSingle");

        scrollToTargetText(from);
        selectTargetText(from, from + replaceText.length);
      }
    },
    async enabledReplaceAll(value: boolean) {
      const { searchText, replaceText } = this;

      if (value) {
        const replacedContent = this.content.replaceAll(searchText, replaceText);
        this.content = replacedContent; // WARNING: contentを直接変更しているため、undoが効かなくなる
        this.$store.dispatch("manuscriptModule/toggleEnabledReplaceAll");
      }
    },
    async restoredContent(value: string | null) {
      if (typeof value !== "string") return;

      // contentに反映する前に、現在の変更を保存する
      if (this.changed) await this.save();

      this.content = value;
      this.$store.dispatch("manuscriptModule/initializeRestoredContent");
    },
  },

  computed: {
    novel() {
      const { novelId } = this;
      const { getters } = this.$store;
      const novel = getters["novelModule/novel"](novelId) as Novel | undefined;
      return novel;
    },
    manuscript() {
      const { getters } = this.$store;
      return getters["manuscriptModule/manuscript"](this.manuscriptKey);
    },
    changed() {
      return this.preTitle !== this.title || this.preContent !== this.content;
    },
    exceeded() {
      return this.contentLength > contentMaxLenth;
    },
    contentLength() {
      let rubyLength = 0;
      const content = clone(this.content) as string;

      // eslint-disable-next-line no-control-regex
      const rubyRegExp = new RegExp("[|｜][^|｜\r\n]*?《.*?》", "gu");
      const textWithRuby = content.match(rubyRegExp);
      if (textWithRuby) {
        textWithRuby.forEach((text) => {
          const onlyRubyRegExp = new RegExp("《.*?》$");
          const textOnlyRuby = text.match(onlyRubyRegExp);
          rubyLength += textOnlyRuby![0].length + 1; // 親文字の縦棒をカウントから除くための+1
        });
      }

      let contentLength = 0;
      switch (this.countType) {
        case "addBlank":
          contentLength = content.replace(/\n/g, "").length;
          break;
        case "addNewLine":
          contentLength = content.replace(/[^\S\n]/g, "").length;
          break;
        case "all":
          contentLength = content.length;
          break;
        case "onlyCharacter":
        default:
          contentLength = content.replace(/\s+|\n/g, "").length;
          break;
      }

      return contentLength - rubyLength;
    },
    pageCount() {
      const content = clone(this.content) as string;

      /** ルビを除外する */
      const splittedContent = content.split("\n");
      const removedRubyContent = splittedContent.map((content) => {
        let result = content;
        // eslint-disable-next-line no-control-regex
        const rubyRegExp = new RegExp("[|｜][^|｜\r\n]*?《.*?》", "gu");
        const textWithRuby = content.match(rubyRegExp);
        if (textWithRuby) {
          textWithRuby.forEach((text: string) => {
            let replaceText = text;
            const parentRegExp = new RegExp("[|｜]");
            replaceText = replaceText.replace(parentRegExp, "");
            replaceText = replaceText.replace("《.*?》", "");
            result = content.replace(text, replaceText);
          });
        }
        return result;
      });

      /** 原稿の設定情報を取得 */
      const { wordCountOnVertical, lineCountPerPage } = this.manuscriptSetting as ManuscriptSetting;

      /** 行数を計算する */
      let lineCount = 0;
      removedRubyContent.forEach(
        (content) => (lineCount += content ? Math.ceil(content.length / wordCountOnVertical) : 1)
      );
      return Math.ceil(lineCount / lineCountPerPage);
    },
    onlyCharacterWordCount() {
      const content = clone(this.content) as string;

      let rubyLength = 0;
      // eslint-disable-next-line no-control-regex
      const rubyRegExp = new RegExp("[|｜][^|｜\r\n]*?《.*?》", "gu");
      const textWithRuby = content.match(rubyRegExp);
      if (textWithRuby) {
        textWithRuby.forEach((text) => {
          const onlyRubyRegExp = new RegExp("《.*?》$");
          const textOnlyRuby = text.match(onlyRubyRegExp);
          rubyLength += textOnlyRuby![0].length + 1; // 親文字の縦棒をカウントから除くための+1
        });
      }

      const contentLength = content.replace(/\s+|\n/g, "").length;

      return contentLength - rubyLength;
    },
    isShowPreview() {
      const { $store, isFree } = this;
      const { getters } = $store;

      const isShowPreview = getters["manuscriptModule/isShowPreviewOnManuscriptEditor"];

      return !isFree && isShowPreview;
    },
    manuscriptList() {
      const key = this.manuscriptKey;
      const { title, content } = this;
      const manuscriptObject: Manuscript = {
        key,
        title,
        content,
      };
      return [manuscriptObject];
    },
    theme() {
      return this.$store.getters["manuscriptModule/theme"];
    },
    isShowPublishSharedLink() {
      return this.$store.getters["sharedLinkModule/isShowPublishSharedLink"];
    },
    countType() {
      return this.$store.getters["manuscriptModule/countType"];
    },
    countTypeName() {
      const countTypeValue = this.countType;
      const countType = (this.countTypeList as Item[]).find((countType) => countType.value === countTypeValue);
      const countTypeName = countType ? countType.name : "";

      /** 原稿の設定情報を取得 */
      const { wordCountOnVertical, lineCountPerPage } = this.manuscriptSetting as ManuscriptSetting;

      return `${countTypeName}（縦${wordCountOnVertical}×横${lineCountPerPage}）`;
    },
    wordCountInfo() {
      const { contentLength } = this;
      const { pageCount } = this;

      return `${contentLength}字（${pageCount}P換算）`;
    },
    plan() {
      return this.$store.getters["userModule/plan"] as Plan;
    },
    isFree() {
      return this.plan === Plan.free;
    },
    manuscriptSetting() {
      return this.$store.getters["novelModule/manuscriptSetting"](this.novelId) as ManuscriptSetting;
    },
    saveTimeout() {
      return this.$store.getters["manuscriptModule/saveTimeout"];
    },
    saveStatus() {
      const { autoSave, saved } = this;

      if (autoSave) {
        return saved ? "自動保存しました" : "自動保存設定中";
      }
      return saved ? "保存しました" : "";
    },
    lastModified() {
      return this.manuscript && this.manuscript.lastModified ? `最終保存：${this.manuscript.lastModified}` : "";
    },
    autoSave() {
      return this.$store.getters["manuscriptModule/autoSave"];
    },
    isShowEditorController() {
      return this.$store.getters["manuscriptModule/isShowEditorController"];
    },
    autoIndent() {
      return this.$store.getters["manuscriptModule/autoIndent"];
    },
    hamburgerMenuTogglableItems() {
      const {
        autoSave,
        toggleAutoSave,
        autoIndent,
        toggleAutoIndent,
        isShowEditorController,
        toggleShowEditorController,
      } = this;

      const hamburgerMenuTogglableItems: Item[] = [
        {
          name: "自動字下げ",
          icon: "format-indent-increase",
          value: autoIndent,
          callback() {
            toggleAutoIndent();
          },
        },
        {
          name: "自動保存",
          icon: "content-save-outline",
          value: autoSave,
          callback() {
            toggleAutoSave();
          },
        },
        {
          name: "コントロールバーの表示",
          icon: "toolbox-outline",
          value: isShowEditorController,
          callback() {
            toggleShowEditorController();
          },
        },
      ];

      return hamburgerMenuTogglableItems;
    },
    textareaElement() {
      return document.getElementById("textarea") as HTMLTextAreaElement;
    },
    enabledSearchReplace() {
      return this.$store.getters["manuscriptModule/enabledSearchReplace"];
    },
    enabledReplace() {
      return this.$store.getters["manuscriptModule/enabledReplace"];
    },
    searchText() {
      return this.$store.getters["manuscriptModule/searchText"];
    },
    replaceText() {
      return this.$store.getters["manuscriptModule/replaceText"];
    },
    enabledSearch() {
      return this.$store.getters["manuscriptModule/enabledSearch"];
    },
    enabledReplaceSingle() {
      return this.$store.getters["manuscriptModule/enabledReplaceSingle"];
    },
    enabledReplaceAll() {
      return this.$store.getters["manuscriptModule/enabledReplaceAll"];
    },
    searchTargetIndex() {
      return this.$store.getters["manuscriptModule/searchTargetIndex"];
    },
    searchTotalCount() {
      return this.$store.getters["manuscriptModule/searchTotalCount"];
    },
    searchTextIndexList() {
      return this.$store.getters["manuscriptModule/searchTextIndexList"];
    },
    restoredContent() {
      return this.$store.getters["manuscriptModule/restoredContent"];
    },

    // NolaNovel

    novelIdFromNolaNovel() {
      const { novel } = this;

      if (!novel) {
        return undefined;
      }

      const { associatedData } = novel as Novel;

      if (!associatedData) {
        return undefined;
      }

      const { nolaNovel } = associatedData;

      if (!nolaNovel) {
        return undefined;
      }

      const { id } = nolaNovel;

      if (!id) {
        return undefined;
      }

      return id;
    },
    episodeIdFromNolaNovel() {
      const { manuscript } = this;
      if (!manuscript) {
        return undefined;
      }

      const { associatedData } = manuscript as Manuscript;

      if (!associatedData) {
        return undefined;
      }

      const { nolaNovel } = associatedData;

      if (!nolaNovel) {
        return undefined;
      }

      const { id } = nolaNovel;

      if (!id) {
        return undefined;
      }

      return id;
    },
  },

  methods: {
    // initialize

    async initialize() {
      const { manuscript } = this;
      const { title, content } = manuscript;
      this.title = title || "";
      this.content = content || "";
      this.preTitle = String(this.title);
      this.preContent = String(this.content);

      // set RecordWordCount
      this.$store.commit("manuscriptModule/setBaseWordCount", this.onlyCharacterWordCount);

      try {
        const results = await new UserClient().checkConnectedOtherServices();
        const { nolaNovel } = results;
        if (nolaNovel) {
          this.hasNolaNovelAccount = nolaNovel.result ?? false;
        }
      } catch (e) {
        // 特にエラーでも何もしない
      }

      const {
        hamburgerMenuItems,
        episodeIdFromNolaNovel,
        onExportButtonClick,
        showNolaNovelDelinkConfirmDialog,
      } = this;
      const item: Item = {
        name: "Nolaノベルで作品を公開する",
        icon: "export-variant",
        callback: () => {
          onExportButtonClick(episodeIdFromNolaNovel !== undefined);
        },
      };

      if (episodeIdFromNolaNovel) {
        item.name = "Nolaノベルとの連携を解除する";
        item.callback = () => showNolaNovelDelinkConfirmDialog(episodeIdFromNolaNovel);
      }

      this.hamburgerMenuItems = hamburgerMenuItems.filter(
        (item) => item.name !== "Nolaノベルで作品を公開する" && item.name !== "Nolaノベルとの連携を解除する"
      );
      this.hamburgerMenuItems.unshift(item);
    },

    // execute

    async save() {
      const { novelId, title, content, manuscriptKey, changed } = this;

      if (!changed) return;

      if (this.contentLength > contentMaxLenth) {
        this.showErrorDialog(
          "本文の文字数が10万字を越えています。<br />10万字以内に編集して再度保存を実行してください。<br />※別の原稿にて続きをお書きください。"
        );
        return;
      }

      const key = manuscriptKey;
      this.$store.dispatch("manuscriptModule/updateManuscript", {
        novelId,
        key,
        title,
        content,
        callback: async () => {
          this.preTitle = clone(title);
          this.preContent = clone(content);
          this.setModified(false);

          this.saved = true;
          setTimeout(() => (this.saved = false), 2000);

          this.$notify({
            title: "保存しました",
            type: "success",
            duration: 2000,
          });
        },
      });
      this.$store.dispatch("manuscriptModule/incrementWritingCount", {
        novelId,
        value: this.onlyCharacterWordCount,
      });
    },
    async goToMultiEditor() {
      const { novelId, manuscriptKey } = this;
      if (this.isFree) {
        // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
        // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
        // const data: PremiumFeatureDialogProps = {
        //   title: "マルチ執筆モードはプレミアム機能です",
        //   text: "Nolaプレミアムにご登録いただくと【全画面表示】で【資料を見ながら】執筆が可能な『マルチ執筆モード』をご利用いただけます。執筆がリアルタイムに反映される縦書きプレビューも同時にご利用いただけますので、お手すきの際にぜひご利用いただけますと幸いです。",
        //   image: (await downloadPublicImage("shared/images/gif/manuscript_multi_editor.gif")) as string,
        // };
        // premiumFeatureDialog.show(data);

        this.$router.push({ name: "subscriptionAnnounce", query: { from: "multiEditor" } });

        return;
      }

      this.$router.push({
        name: "multiEditor",
        params: {
          novelId,
          manuscriptKey,
        },
      });
    },
    navigateToNolaNovelEditPage(id: string) {
      let url = process.env.VUE_APP_NOLANOVEL_WEB;

      if (!url) {
        throw new Error("NolaノベルのWebサイトURLが環境変数に含まれていません。");
      }

      const { novelId, manuscript } = this;
      url = `${url}/episode/edit/${id}?novelid=${novelId}&episodeid=${manuscript.key}`;
      window.open(url, process.env.VUE_APP_NOLANOVEL_NAME ?? "");
    },
    executeReplaceText(from, to) {
      const { textareaElement, replaceText } = this;
      textareaElement.selectionStart = from;
      textareaElement.selectionEnd = to;
      textareaElement.focus();
      document.execCommand("insertText", false, replaceText);
    },
    initializeSearchState() {
      this.disableSearchReplace();
      this.$store.dispatch("manuscriptModule/updateSearchText", "");
      this.$store.dispatch("manuscriptModule/updateReplaceText", "");
    },
    updateSearchState() {
      const { searchText } = this;
      let searchTextIndexList: SearchTextIndex[] = [];
      if (searchText) {
        const escapedText = searchText.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const searchRegExp = new RegExp(`${escapedText}`, "gu");
        const iterator = this.content.matchAll(searchRegExp);
        const indexArray = [...iterator].map((x) => x.index);
        searchTextIndexList = indexArray.map((startIndex) => {
          if (startIndex) {
            return {
              from: startIndex,
              to: startIndex + searchText.length,
            };
          }
          return {
            from: 0,
            to: 0,
          };
        });
      }
      this.$store.dispatch("manuscriptModule/updateSearchTextIndexList", searchTextIndexList);
      this.$store.dispatch("manuscriptModule/updateSearchTargetIndex", 0);
      this.$store.dispatch("manuscriptModule/updateSearchTotalCount", searchTextIndexList.length);
    },

    // event handle

    async handleBackAction() {
      const { novelId, changed } = this;
      if (changed) {
        const yes = await showOkCancelDialog({
          title: "確認",
          content: "保存されていない変更があります。<br />変更を破棄して戻りますか？",
          okButton: "破棄する",
          cancelButton: "キャンセル",
        });
        if (!yes) {
          return;
        }
      }

      this.$router.push({ name: "editor", params: { novelId } });
    },
    onExportButtonClick(isPost) {
      const { hasNolaNovelAccount } = this;
      if (!hasNolaNovelAccount) {
        const introduction = new Dialog(NolaNovelIntroduction);
        introduction.show();
        return;
      }

      const { changed, showUnsavedConfirm } = this;
      if (changed) {
        showUnsavedConfirm();
        return;
      }

      const { episodeIdFromNolaNovel, showNolaNovelExportConfirm } = this;

      if (episodeIdFromNolaNovel) {
        showNolaNovelExportConfirm(episodeIdFromNolaNovel);
        return;
      }

      const { showNolaNovelListDialog } = this;
      showNolaNovelListDialog(isPost);
    },
    async onClickPreview() {
      if (this.isFree) {
        // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
        // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
        // const data: PremiumFeatureDialogProps = {
        //   title: "執筆時の縦書きプレビューはプレミアム機能です",
        //   text: "Nolaプレミアムにご登録いただくと、原稿の執筆時にリアルタイムで反映される『縦書きプレビュー機能』をご利用いただけます。一行辺りの文字数やページ辺りの行数も設定可能ですので、お手すきの際にぜひご活用いただだけたら幸いです。",
        //   image: (await downloadPublicImage("shared/images/gif/manuscript_vertical_writing.gif")) as string,
        // };
        // premiumFeatureDialog.show(data);

        this.$router.push({ name: "subscriptionAnnounce", query: { from: "verticalWriting" } });

        return;
      }
      this.$store.dispatch("manuscriptModule/switchPreviewOnManuscriptEditor");
    },
    async onChangeTitle(args) {
      const { value, isComposing } = args;

      this.title = value;
      this.setModified(this.changed);

      if (this.changed && this.autoSave && !isComposing) {
        this.$store.dispatch("manuscriptModule/startSaveTimeout");
      }
    },
    async onChangeContent(args) {
      const { value, isComposing } = args;

      this.content = value;
      this.setModified(this.changed);

      if (this.changed && this.autoSave && !isComposing) {
        this.$store.dispatch("manuscriptModule/startSaveTimeout");
      }
    },
    onStartComposition() {
      if (this.changed && this.autoSave) {
        this.$store.dispatch("manuscriptModule/stopSaveTimeout");
      }
    },
    onEndComposition() {
      if (this.changed && this.autoSave) {
        this.$store.dispatch("manuscriptModule/startSaveTimeout");
      }
    },
    onSelectCountType(countTypeValue) {
      this.$store.dispatch("manuscriptModule/selectCountType", countTypeValue);
    },
    toggleAutoSave() {
      this.$store.dispatch("manuscriptModule/toggleAutoSave");
    },
    toggleShowEditorController() {
      this.$store.dispatch("manuscriptModule/toggleShowEditorController");
    },
    toggleAutoIndent() {
      this.$store.dispatch("manuscriptModule/toggleAutoIndent");
    },
    enableSearchReplace(e) {
      const { $store, enabledSearchReplace, isShowEditorController } = this;
      if (!isShowEditorController) return;

      // ブラウザの検索を無効にする
      e.preventDefault();

      if (!enabledSearchReplace) $store.dispatch("manuscriptModule/toggleEnabledSearchReplace");

      const selectedText = window.getSelection()!.toString();
      if (selectedText) $store.dispatch("manuscriptModule/updateSearchText", selectedText);
    },
    enableReplace(e) {
      const { $store, enabledReplace, enableSearchReplace } = this;
      enableSearchReplace(e);
      if (!enabledReplace) $store.dispatch("manuscriptModule/toggleEnabledReplace");
    },
    disableSearchReplace() {
      if (this.enabledSearchReplace) this.$store.dispatch("manuscriptModule/toggleEnabledSearchReplace");
    },
    scrollToTargetText(to) {
      // NOTE: 検索対象文字がtextareaの表示外にあるとき、検索対象文字までスクロールさせる
      const { textareaElement } = this;
      textareaElement.selectionStart = to;
      textareaElement.selectionEnd = to;
      textareaElement.blur();
      textareaElement.focus();
    },
    selectTargetText(from, to) {
      const { textareaElement } = this;
      textareaElement.selectionStart = from;
      textareaElement.selectionEnd = to;
      textareaElement.focus();
    },
    focusInputSearch() {
      const inputSearchElement = document.getElementById("inputSearch") as HTMLInputElement;
      inputSearchElement.focus();
    },

    // view

    showUnsavedConfirm() {
      const completeDialog = new Dialog(CupertinoAlertDialog);
      const data: CupertinoAlertDialogProps = {
        title: "未保存の内容があります",
        content: "未保存のデータがあります。保存を実行してから投稿することが可能です。",
        action: "閉じる",
      };
      completeDialog.show(data);
    },
    showManuscriptSettings() {
      const { novelId, plan } = this;
      const manuscriptSettingsDialog = new Dialog(ManuscriptSettingsDialog);
      const data: ManuscriptSettingsDialogProps = {
        novelId,
        isChangeable: Boolean(plan),
        positive: "保存する",
        positiveCallback: async () => {},
      };
      manuscriptSettingsDialog.show(data);
    },
    showColorTheme() {
      const colorThemeDialog = new Dialog(ColorThemeDialog);
      colorThemeDialog.show();
    },
    showProofreadingSettings() {
      const proofreadingDialog = new Dialog(ProofreadingSettingsDialog);
      proofreadingDialog.show();
    },
    showExportManuscriptPdf() {
      const { novelId } = this;
      const exportManuscriptPdfDialog = new Dialog(ExportManuscriptPdfDialog);
      const data: ExportManuscriptPdfDialogProps = {
        novelId,
      };
      exportManuscriptPdfDialog.show(data);
    },
    showVersions() {
      const { novelId, manuscriptKey, content } = this;
      const versionsDialog = new Dialog(VersionsDialog);
      const data: VersionsDialogProps = { novelId, manuscriptKey, content };
      versionsDialog.show(data);
    },
    async showMenu() {
      openManuscriptEditorMenuDialog();
    },
    showErrorDialog(message: string) {
      const confirmDialog = new Dialog(DialogVue);
      const options = {
        title: "エラー",
        content: message,
      };

      confirmDialog.show(options);
    },
    showPublishSharedLink() {
      this.$store.dispatch("sharedLinkModule/showPublishSharedLink");
    },
    async showNolaNovelExportConfirm(id) {
      const confirmDialog = new Dialog(NolaNovelUpdateConfirm);
      const data: NolaNovelUpdateConfirmProps = {
        id,
        content: `この原稿を、Nolaノベル上に投稿された連携済みエピソードに上書きしてよろしいですか？`,
      };
      const result = await confirmDialog.show(data);
      const { navigateToNolaNovelEditPage } = this;
      if (result) {
        navigateToNolaNovelEditPage(id);
      }
    },
    async showNolaNovelListDialog(isPost: boolean) {
      const { novelId, manuscriptKey, novelIdFromNolaNovel } = this;
      const novelListDialog = new Dialog(EpisodeListDialog);
      const data: EpisodeListDialogProps = {
        novelId,
        manuscriptId: manuscriptKey,
        isPost,
        novelIdFromNolaNovel,
      };

      const result = await novelListDialog.show(data);
      if (result) {
        const completeDialog = new Dialog(CupertinoAlertDialog);
        const data: CupertinoAlertDialogProps = {
          title: "連携が完了しました",
          content: "今後はこの原稿をNolaからNolaノベルに投稿する際は、自動でエピソードが選択されます。",
          action: "閉じる",
        };
        completeDialog.show(data);
      }

      const { initialize } = this;
      initialize();
    },
    async showNolaNovelDelinkConfirmDialog(id) {
      const { novelId, manuscriptKey } = this;
      const deleteDialog = new Dialog(EpisodeDelinkConfirm);
      const data: EpisodeDelinkConfirmProps = {
        novelId,
        manuscriptId: manuscriptKey,
        episodeId: id,
      };

      const result = await deleteDialog.show(data);
      if (result) {
        const completeDialog = new Dialog(CupertinoAlertDialog);
        const data: CupertinoAlertDialogProps = {
          title: "連携を解除しました",
          content:
            "再度連携を行う場合は、Nolaノベルアイコンまたはメニュー内の「Nolaノベルと連携する」を選択してください。",
          action: "閉じる",
        };
        completeDialog.show(data);
      }

      const { initialize } = this;
      initialize();
    },
  },
});

interface Props {
  novelId: string;
  manuscriptKey: string;
}

interface Data {
  title: string;
  preTitle: string;
  content: string;
  preContent: string;
  saved: boolean;
  countTypeList: Item[];
  hamburgerMenuItems: Item[];
  hasNolaNovelAccount: boolean;
}

interface Methods {
  initialize(): void;

  save(): Promise<void>;
  handleBackAction(): Promise<void>;
  goToMultiEditor(): Promise<void>;
  navigateToNolaNovelEditPage(id: string): void;
  executeReplaceText(from: number, to: number): void;
  initializeSearchState(): void;
  updateSearchState(): void;

  onClickPreview(): void;
  onSelectCountType(countTypeValue: any): void;
  onChangeTitle(args: IEditorEmitArgs): Promise<void>;
  onChangeContent(args: IEditorEmitArgs): Promise<void>;
  onStartComposition(): void;
  onEndComposition(): void;
  onExportButtonClick(isPost: boolean): void;
  toggleAutoSave(): void;
  toggleShowEditorController(): void;
  toggleAutoIndent(): void;
  enableSearchReplace(e: Event): void;
  enableReplace(e: Event): void;
  disableSearchReplace(): void;
  scrollToTargetText(to: number): void;
  selectTargetText(from: number, to: number): void;
  focusInputSearch(): void;

  showUnsavedConfirm(): void;
  showMenu(): Promise<void>;
  showPublishSharedLink(): void;
  showErrorDialog(message: string): void;
  showManuscriptSettings(): void;
  showProofreadingSettings(): void;
  showColorTheme(): void;
  showExportManuscriptPdf(): void;
  showVersions(): void;
  showNolaNovelExportConfirm(id: string): void;
  showNolaNovelListDialog(isPost: boolean): void;
  showNolaNovelDelinkConfirmDialog(id: string): void;
}

interface Computed {
  novel?: Novel;
  manuscript: Manuscript;
  changed: boolean;
  exceeded: boolean;
  contentLength: number;
  pageCount: number;
  onlyCharacterWordCount: number;
  isShowPreview: boolean;
  manuscriptList: Manuscript[];
  theme: string;
  isShowPublishSharedLink: boolean;
  countType: string;
  countTypeName: string;
  wordCountInfo: string;
  plan: Plan;
  isFree: boolean;
  manuscriptSetting: ManuscriptSetting;
  saveTimeout: boolean;
  saveStatus: string;
  lastModified: string;
  autoSave: boolean;
  isShowEditorController: boolean;
  autoIndent: boolean;
  hamburgerMenuTogglableItems: Item[];
  textareaElement: HTMLTextAreaElement;
  enabledSearchReplace: boolean;
  enabledReplace: boolean;
  searchText: string;
  replaceText: string;
  enabledSearch: boolean;
  enabledReplaceSingle: boolean;
  enabledReplaceAll: boolean;
  searchTargetIndex: number;
  searchTotalCount: number;
  searchTextIndexList: SearchTextIndex[];
  restoredContent: string | null;

  // NolaNovel
  novelIdFromNolaNovel?: string;
  episodeIdFromNolaNovel?: string;
}
